import { render, staticRenderFns } from "./CategoryTabs.vue?vue&type=template&id=28e2bec0&scoped=true"
import script from "./CategoryTabs.vue?vue&type=script&lang=ts"
export * from "./CategoryTabs.vue?vue&type=script&lang=ts"
import style0 from "./CategoryTabs.vue?vue&type=style&index=0&id=28e2bec0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e2bec0",
  null
  
)

export default component.exports